<script>
import { mapActions } from 'vuex'
import UserAvatar from '@/components/user/user-avatar.vue'

export default {
  name: 'CandidateImage',
  components: { UserAvatar },
  props: {
    size: {
      type: String,
      default: 'xxl',
    },
    fontSize: {
      type: Number,
      default: null,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    showPreferredIcon: {
      type: Boolean,
      required: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    firstName: {
      type: String,
      default: null,
    },
    lastName: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {
      profileImgSrc: null,
    }
  },
  computed: {
    compFullName() {
      return this.id > 0 ? `${this.firstName} ${this.lastName}` : `- -`
    },
  },
  async created() {
    const dpResponse = await this.getDisplayPic(this.id)
    if (dpResponse.data !== null) {
      this.profileImgSrc = `data:image/jpeg;base64,${dpResponse.data}`
      this.$emit('profileImgSrc', this.profileImgSrc)
    }
  },
  methods: {
    ...mapActions({
      getDisplayPic: 'candidate/getDisplayPic',
    }),
  },
}
</script>

<template>
  <div class="candidateImage mr-5">
    <UserAvatar
      :name="compFullName"
      :size="size"
      :font-size="fontSize"
      :clickable="id > 0 && clickable"
      :rounded="rounded"
      :badge="showPreferredIcon"
      badge-icon="mdi-star"
      badge-color="orange accent-2"
      :image-url="profileImgSrc"
      @click="$emit('click')"
    />
  </div>
</template>
